import {removeNode} from '@acng/frontend-bounty';
import {defineRenderAttribute} from '@acng/frontend-stargazer';
import {hasMyPortal} from 'acng/core/service/env';

defineRenderAttribute(':if-myportal', (element, value) => {
  if (hasMyPortal === (value == 'not')) {
    removeNode(element);
  }
});
